document.addEventListener("DOMContentLoaded", function () {
  const track = document.querySelector(".slider-items");
  const progressContainer = document.querySelector(".progress-container");
  const progressBar = document.querySelector(".progress-bar");
  const prevBtn = document.querySelector(".prev-btn");
  const nextBtn = document.querySelector(".next-btn");

  const updateSliderUI = () => {
    const scrollLeft = track.scrollLeft;
    const scrollTotal = track.scrollWidth - track.clientWidth;

    let scrollPercentage = scrollTotal > 0 ? scrollLeft / scrollTotal : 0;
    scrollPercentage = Math.max(0, Math.min(1, scrollPercentage));

    const barWidth = 30;
    const maxLeft = 100 - barWidth;
    const position = scrollPercentage * maxLeft;

    progressBar.style.left = `${position}%`;
    progressContainer.setAttribute("aria-valuenow", Math.round(scrollPercentage * 100));

    const isAtStart = scrollLeft <= 5;
    const isAtEnd = scrollLeft >= scrollTotal - 5;

    prevBtn.style.opacity = isAtStart ? "0.2" : "1";
    prevBtn.style.pointerEvents = isAtStart ? "none" : "auto";
    prevBtn.setAttribute("aria-disabled", isAtStart ? "true" : "false");

    nextBtn.style.opacity = isAtEnd ? "0.2" : "1";
    nextBtn.style.pointerEvents = isAtEnd ? "none" : "auto";
    nextBtn.setAttribute("aria-disabled", isAtEnd ? "true" : "false");
  };

  track.addEventListener("scroll", updateSliderUI);

  nextBtn.addEventListener("click", () => {
    if (nextBtn.getAttribute("aria-disabled") === "true") return;
    track.scrollBy({ left: 197, behavior: "smooth" });
  });

  prevBtn.addEventListener("click", () => {
    if (prevBtn.getAttribute("aria-disabled") === "true") return;
    track.scrollBy({ left: -197, behavior: "smooth" });
  });

  updateSliderUI();
});
